import { createSlice } from '@reduxjs/toolkit'
import { languages } from '../../../../configs/language'
import { register, syncInitialState } from '../../../helpers/reducerRegistry'
import { TIME_PERIOD_LIST } from '../constants'
import { getDataTable, handleOptions } from '../helpers'
import { getFiltersThunk, getNewsAndSocials } from './thunk'

const name = 'companyAnalysis/newsAndSocial'
const initialState = {
  isFinishLoadFilters: false,
  newsTypes: [],
  sentiments: [],
  languages: [
    {
      name: 'newsAndSocial.VIETNAMESE',
      value: languages.vi,
      isChecked: false,
    },
    {
      name: 'newsAndSocial.ENGLISH',
      value: languages.en,
      isChecked: false,
    },
  ],

  data: [],
  dataTable: {},
  ids: [],

  isBookmark: false,
  isLoading: true,
  totalRecords: 0,
  totalPage: 0,
  page: 1,
  pageSize: 20,
  searchText: undefined,
  startDate: undefined,
  endDate: undefined,

  activeTimePeriod: TIME_PERIOD_LIST.allTime,
}
const persistKeys = [
  'newsTypes',
  'sentiments',
  'languages',
  'isBookmark',
  'activeTimePeriod',
  'startDate',
  'endDate',
]

const slice = createSlice({
  name,
  initialState: syncInitialState({ name, initialState, persistKeys }),
  reducers: {
    changeIsBookmark: (state, action) => {
      state.isBookmark = action.payload
    },
    changeNewsTypes: (state, action) => {
      state.newsTypes = action.payload
    },
    changeSentiments: (state, action) => {
      state.sentiments = action.payload
    },
    changePageSize: (state, action) => {
      state.pageSize = action.payload
    },
    changePage: (state, action) => {
      state.page = action.payload
    },
    changeIds: (state, action) => {
      state.ids = action.payload
    },
    changeSearchText: (state, action) => {
      state.searchText = action.payload
    },
    changeStartDate: (state, action) => {
      state.startDate = action.payload
    },
    changeEndDate: (state, action) => {
      state.endDate = action.payload
    },
    changeActiveTimePeriod: (state, action) => {
      state.activeTimePeriod = action.payload
    },
    changeLanguages: (state, action) => {
      state.languages = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFiltersThunk.fulfilled, (state, { payload = [] }) => {
      state.isFinishLoadFilters = true
      const [newsTypes, sentiments] = payload

      state.newsTypes = handleOptions(
        newsTypes.map((item) => ({
          ...item,
          children: item.child_NewsTypeResponse || [],
        })),
        state.newsTypes,
        'newsCategoryId',
      )
      state.sentiments = handleOptions(
        sentiments,
        state.sentiments,
        'newsTypeId',
      )
    })

    builder.addCase(getNewsAndSocials.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getNewsAndSocials.fulfilled, (state, { payload = {} }) => {
      state.isLoading = false
      const { totalRecords, totalPage, data = [] } = payload
      state.totalRecords = totalRecords
      state.totalPage = totalPage

      state.data = data
      state.ids = data.map((item) => item.newsId)
      state.dataTable = getDataTable(data, state.ids)
    })
    builder.addCase(getNewsAndSocials.rejected, (state, action) => {
      state.isLoading = action.payload.isLoading
    })
  },
})

export const selectNewsType = (state) => state[slice.name].newsTypes
export const selectSentiments = (state) => state[slice.name].sentiments
export const selectIsFinishLoadFilters = (state) =>
  state[slice.name].isFinishLoadFilters
export const selectIsBookmark = (state) => state[slice.name].isBookmark
export const selectPage = (state) => state[slice.name].page
export const selectPageSize = (state) => state[slice.name].pageSize
export const selectTotalRecords = (state) => state[slice.name].totalRecords
export const selectIsLoading = (state) => state[slice.name].isLoading
export const selectSearchText = (state) => state[slice.name].searchText
export const selectStartDate = (state) => state[slice.name].startDate
export const selectEndDate = (state) => state[slice.name].endDate
export const selectIds = (state) => state[slice.name].ids
export const selectTableItem = (rowId, colId) => (state) =>
  state[slice.name].dataTable[rowId][colId]
export const selectRowItem = (rowId) => (state) =>
  state[slice.name].dataTable[rowId]
export const selectActiveTimePeriod = (state) =>
  state[slice.name].activeTimePeriod
export const selectLanguages = (state) => state[slice.name].languages

export const {
  changeIsBookmark,
  changeNewsTypes,
  changeSentiments,
  changePageSize,
  changePage,
  changeIds,
  changeSearchText,
  changeStartDate,
  changeEndDate,
  changeActiveTimePeriod,
  changeLanguages,
} = slice.actions

register(slice.name, slice.reducer, persistKeys)
